// src/features/session/session.slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Session, SessionMenuItem } from '../../models/session';
import { SessionState } from './session.types';

const initialState: SessionState = {
  sessionId: null,
  session: null,
  menuItems: [],
  loading: false,
  error: null,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSessionId: (state, action: PayloadAction<string|null>) => {
      state.sessionId = action.payload;
      state.loading = true;
    },
    sessionUpdated: (state, action: PayloadAction<Session>) => {
      state.session = action.payload;
      state.loading = false;
      state.error = null;
    },
    sessionListenerError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    sessionMenuItemUpdated: (state, action: PayloadAction<SessionMenuItem[]>) => {
      state.menuItems = action.payload;
      state.loading = false;
      state.error = null;
    },
    resetSession: (state) => {
      state.session = null;
      state.loading = false;
      state.error = null;
    },
    resetSessionMenuItem: (state) => {
      state.menuItems = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setSessionId,
  sessionUpdated,
  sessionListenerError,
  sessionMenuItemUpdated,
  resetSession,
  resetSessionMenuItem,
} = sessionSlice.actions;

export default sessionSlice.reducer;
